<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4" cols="12">
        <h1 class="font-weight-bold mb-3">
          Índice de enfriamiento para corderos recién nacidos
        </h1>
        <h3 class="font-weight-bold ">
          Criadero Ovino Agrícola Cahuala
        </h3>
      </v-col>
    </v-row>
    <div v-if="!hasUserLocation">
      <search-location  @locationSelected="locationSelected"/>
    </div>
    <div v-if="hasUserLocation && userLocation">
      <v-card color="brown lighten-4">
        <v-card-text>
          Mostrando datos para: <span class="text-h5">
          {{ userLocation.name }} ({{ userLocation.region.name }} 
            / {{ userLocation.country.name}})
          </span>
        </v-card-text>
        <v-card-actions class="text-center">
          <v-btn @click="cleanLocation" class="text-center" color="warning">Volver a buscar</v-btn>
        </v-card-actions>
      </v-card>
      
      <weather-info v-bind:location="userLocation" />
    </div>
  </v-container>
</template>
<script>
// @ is an alias to /src
import SearchLocation from '@/components/SearchLocation.vue';
import WeatherInfo from '@/components/WeatherInfo.vue';

export default {
  name: 'Home',
  components: {
    SearchLocation,
    WeatherInfo
  },
  data() {
    return {
      hasUserLocation: true,
      userLocation: null,
    }
  },
  mounted() {
    if (localStorage.getItem('user_location')) {
      try {
        this.userLocation = JSON.parse(localStorage.getItem('user_location'));
        this.hasUserLocation = true;
      } catch(e) {
        localStorage.removeItem('user_location');
        this.hasUserLocation = false;
      }
    }else {
      this.hasUserLocation = false;
    }
  },
  methods: {
    locationSelected(location) {
      this.userLocation = location;
      localStorage.setItem('user_location', JSON.stringify(location));
      this.hasUserLocation = true;
    },
    cleanLocation() {
    this.hasUserLocation = false;
    this.userLocation = null;
  }
  }

}
</script>
